<template>
    <div class="simple-form">
        <div class="form-group center">
            <div class="form-label">
                <label class="required">审核操作</label>
            </div>
            <div class="form-value width-1-5x">
                <el-radio-group v-model="auditState">
                    <el-radio label="1">通过</el-radio>
                    <el-radio label="-1">驳回</el-radio>
                </el-radio-group>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label" v-if="auditState==1">
                <label class="">备注</label>
            </div>
            <div class="form-label" v-if="auditState==-1">
                <label class="">原因</label>
            </div>
            <div class="form-value width-1-5x">
                <el-input class="textarea-value" type="textarea" v-model="desc"></el-input>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    export default{
        name: 'swb-price-inpry-audit',
        path: '/price/inpry/voucher/audit',
        pathOld: '/price/inpry/audit',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '询价单审核（弹出框）',
        data: function () {
            return {
                auditState: '1',
                desc: null,
            }
        },
        created: function () {
        },
        methods: {
            getDlgResult: function () {
                let self = this;
                let result = {};
                result.type = "info";
                result.auditState = self.auditState;
                result.auditDesc = self.desc;
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/priceInpry/PriceInpryAudit.vue